import config from "../config/config";
import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export async function checkSnippetExists(requestData, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.post("api/checkSnippetExists", {
      ...requestData,
      userKey,
    });
    if (data.data.snippetExists) {
      let fileID = data.data.fileID;
      let url = config.PCA_CLIENT_URL + fileID;
      data.data.url = url;
    }
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export default async function getSnippet(requestData, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.post("api/getSnippet", {
      ...requestData,
      userKey,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function saveSnippet(fileObject, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.post("api/saveSnippet", {
      ...fileObject,
      userKey,
    });
    let fileID = data.data.id;
    let url = config.PCA_CLIENT_URL + fileID;
    data.data.url = url;
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
